import React, { useState } from 'react';
import { Typography, Box, Card } from '@material-ui/core';
import moment from 'moment';
import AccessTimeRoundedIcon from '@material-ui/icons/AccessTimeRounded';
import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForwardRounded';
import { dateMonthYearDateFormat } from '../config/whatsNewConfig';
import { getReleaseAccent } from '../utils/releaseUtils';

const cx = (...classNames) => classNames.filter(Boolean).join(' ');
const VISIBLE_COUNT = 3;
const EXPANDED_VISIBLE_COUNT = 6;

const UpcomingFeaturesCard = ({ features }) => {
    const [isExpanded, setExpanded] = useState(false);
    const canExpand = features?.length > VISIBLE_COUNT;
    const visibleFeatures = isExpanded ? features : features?.slice(0, VISIBLE_COUNT);
    const hasExpandedOverflow = features?.length > EXPANDED_VISIBLE_COUNT;

    const renderFeature = (feature, index) => {
        const accent = getReleaseAccent({ title: feature.feature_title, description: feature.feature_description, application: feature.application });

        return (
            <Box key={feature.id ?? feature.feature_title} className={cx('whats-new-upcoming-feature', index === 0 && 'is-first')} style={{ '--feature-color': accent.main, '--feature-glow': `${accent.main}18` }}>
                <Box className="whats-new-upcoming-feature-row">
                    <Box className="whats-new-upcoming-feature-dot" />
                    <Box className="whats-new-upcoming-feature-text">
                        <Typography className="whats-new-upcoming-feature-title">{feature.feature_title}</Typography>
                        <Typography className="whats-new-upcoming-feature-meta">
                            {feature.application?.label}
                            {feature.feature_expected_release_date ? ` · ${moment(feature.feature_expected_release_date).format(dateMonthYearDateFormat)}` : ''}
                        </Typography>
                        <Typography className="whats-new-upcoming-feature-description">{feature.feature_description}</Typography>
                    </Box>
                </Box>
            </Box>
        );
    };

    return features?.length ? (
        <Card elevation={0} className="whats-new-upcoming-card">
            <Box className="whats-new-upcoming-header">
                <Box className="whats-new-upcoming-header-row">
                    <AccessTimeRoundedIcon />
                    <Typography className="whats-new-upcoming-title">Coming up next</Typography>
                </Box>
                <Typography className="whats-new-upcoming-subtitle">A sneak peek at what our teams are building.</Typography>
            </Box>
            <Box className="whats-new-upcoming-body">
                <Box className={cx('whats-new-upcoming-list', isExpanded && 'is-expanded', isExpanded && hasExpandedOverflow && 'has-overflow')}>
                    {visibleFeatures.map(renderFeature)}
                </Box>
                {canExpand ? (
                    <Box
                        component="button"
                        type="button"
                        className={cx('whats-new-upcoming-footer', isExpanded && 'is-expanded')}
                        onClick={() => setExpanded(prev => !prev)}
                    >
                        {isExpanded ? <ArrowForwardRoundedIcon /> : null}
                        <Typography className="whats-new-upcoming-footer-label">
                            {isExpanded ? 'Show less' : 'Show more'}
                        </Typography>
                        {isExpanded ? null : <ArrowForwardRoundedIcon />}
                    </Box>
                ) : null}
            </Box>
        </Card>
    ) : null;
};

export default UpcomingFeaturesCard;